import { get } from '@submize/lodash';
// eslint-disable-next-line import/no-cycle
import {
  ContainerFields,
  SelectField, SubmitField, InputField, InputsField, TextareaField, TextField, RadioField,
  CheckboxField,
  DatePickerField,
} from '@submize/form';
import React from 'react';
import Selectable from './Selectable';
import Dragable from './Dragable';
import Dropable from './Dropable';

const Fields = {
  Checkbox: CheckboxField,
  DatePicker: DatePickerField,
  Input: InputField,
  Inputs: InputsField,
  Radio: RadioField,
  Select: SelectField,
  Submit: SubmitField,
  Text: TextField,
  Textarea: TextareaField,
};

const AutoFields = ({ fields, moveField }) => fields.map((item, id) => {
  if (item.type === 'Container') return <ContainerFields schema={item.children} />;
  const Field = Fields[item.type] || (() => null);
  const Wrapper = ({ children }) => (
    <Dropable id={item.key} index={id} canDropUp canDropDown={item.type !== 'Submit'}>
      {(item.type === 'Submit' ? children
        : (
          <Dragable id={item.key} index={id} moveField={moveField}>
            {children}
          </Dragable>
        )
    )}
    </Dropable>
  );
  const required = get(item, 'schema.flags.presence', '') === 'required';

  return (
    <Wrapper key={item.key}>
      <Selectable id={item.key} index={id} hideActions={item.type === 'Submit'}>
        <Field
          name={item.key}
          required={required}
          items={item.children}
          {...item.props}
        />
      </Selectable>
    </Wrapper>
  );
});

export default AutoFields;
